import { render } from "./EditKeywordDialog.vue?vue&type=template&id=72d59261"
import script from "./EditKeywordDialog.vue?vue&type=script&lang=js"
export * from "./EditKeywordDialog.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\cloud-api-web-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__